import data from "@/config/template/CustomLoginWithSC/data.json"
import { CurrentAppResp } from "@/page/App/resp/currentAppResp"

export const CUSTOM_LOGIN_WITH_SC_DATA = data as unknown as CurrentAppResp
